import { useNavigate, useParams } from "react-router-dom";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ACTION_TYPE, REPORT_NAME, REPORT_PATH } from "../../constant/reportType";
import { Button } from "react-bootstrap";
import { Switch, Table } from "antd";
import { DEPARTMENT_MASTER_COLUMN } from "../../constant/AppConstant";
import { BsPencilSquare, BsPlus } from "react-icons/bs";
import { alertMessage } from "../../utils/AlertService";
import MasterReportData from "./MasterReportData";
import { useAppSelector } from "../../redux-toolkit/hooks";
import Loading from "../Loading";
import { useDeleteDepartmentMasterMutation, useGetAllDepartmentMasterMutation } from "../../redux-toolkit/services/departmentMasterService";
import { getAllDepartmentMasterDetails, getDepartmentMasterTotalRecords, setDepartmentMaster } from "../../redux-toolkit/slices/departmentMasterSlice";

type Props = {};
const AllMasterReports2 = (props: Props) => {

    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const localUserObj: any = getLocalStorageData("localUser");

    //state
    const [actionType, setActionType] = useState(ACTION_TYPE.ADD_ACTION) as any;
    const [reportName, setReportName]: any = useState();
    const [currentpage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [show, setShow] = useState(false);
    const [selectedRow, setSelectedRow]: any = useState([]);
    const [columData, setColumnData]: any = useState();
    const [dataSource, setDatasource]: any = useState([]);
    const [call, setCall] = useState("N");

    //getMutations
    const [getAllDepartmentMaster, departmentMasterResponse] = useGetAllDepartmentMasterMutation();

    //delete mutation
    const [deleteDepartmentMaster, deleteDepartmentMasterResponse] = useDeleteDepartmentMasterMutation();

    //totalRecords
    const totalDepartmentMaster: any = useAppSelector(getDepartmentMasterTotalRecords);

    //selector
    const departmentMasterData: any = useAppSelector(getAllDepartmentMasterDetails);

    useEffect(() => {
        switch (params.reportType) {
            case REPORT_PATH.DEPARTMENT_MASTER:
                setReportName(REPORT_NAME.DEPARTMENT_MASTER)
                break;
            default:
        }
    }, [params.reportType]);

    useEffect(() => {
        const temp: any = [];
        const tempAction: any = {
            title: "Action",
            dataIndex: "action",
            key: "name",
            fixed: "right",
            width: 120,
            render: (index: any, record: any) => {
                return (
                    // for delete switch button
                    <div className="d-flex justify-content-between">
                        <div className="px-2 pe-auto">
                            <Switch
                                className={`${record.status === true ||
                                    record.enabled === true ||
                                    record.isEnabled === true ? "bg-danger" : "bg-secondry"}`}
                                checked={
                                    record.status === true ||
                                        record.enabled === true ||
                                        record.isEnabled === true
                                        ? true
                                        : false
                                }
                                onClick={() => {
                                    onDeleteData(record);
                                }}
                            />
                        </div>
                        {record.status === true ||
                            record.enabled === true ||
                            record.isEnabled === true ? (
                            <div
                                className="px-2 pe-auto"
                                onClick={() => {
                                    handleOpenForm(record);
                                }}
                            >
                                <BsPencilSquare size={18} />
                            </div>
                        ) : null}
                    </div>
                );
            },
        };

        if (reportName === REPORT_NAME.DEPARTMENT_MASTER && DEPARTMENT_MASTER_COLUMN) {
            DEPARTMENT_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        }
    }, [reportName, params.reportType]);

    useEffect(() => {
        if (reportName === REPORT_NAME.DEPARTMENT_MASTER) {
            getAllDepartmentMaster({
                token: localUserObj.token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "asc"
                }
            });
        }
    }, [reportName]);

    useEffect(() => {
        if (call === "Y") {
            if (reportName === REPORT_NAME.DEPARTMENT_MASTER) {
                getAllDepartmentMaster({
                    token: localUserObj.token,
                    payload: {
                        size: pageSize,
                        page: currentpage - 1,
                        orderBy: "asc"
                    }
                });
                setCall("N");
            }
        }
    }, [call]);

    const paginationChange = (page: number, pageSize: number) => {
        if (reportName === REPORT_NAME.DEPARTMENT_MASTER) {
            getAllDepartmentMaster({
                token: localUserObj.token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        }
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleShow = () => {
        setActionType(ACTION_TYPE.ADD_ACTION);
        setShow(true)
    };

    //delete..........
    const onDeleteData = (record: any) => {
        if (reportName === REPORT_NAME.DEPARTMENT_MASTER) {
            deleteDepartmentMaster({
                id: record.id,
                token: localUserObj.token
            })
        }
    };

    const handleOpenForm = (record: any) => {
        setActionType(ACTION_TYPE.UPDATE_ACTION);
        setSelectedRow(record);
        setShow(true);
    };

    //get allDimensionMaster.......
    useEffect(() => {
        if (departmentMasterResponse.isSuccess) {
            dispatch(setDepartmentMaster(departmentMasterResponse));
        } else if (departmentMasterResponse.isError) {
            alertMessage("Error while fetching department master", "error");
            setDatasource([]);
        }
    }, [departmentMasterResponse.isSuccess, departmentMasterResponse.isError]);

    //data

    useEffect(() => {
        if (departmentMasterData && reportName === REPORT_NAME.DEPARTMENT_MASTER) {
            setDatasource(departmentMasterData);
        }
    }, [departmentMasterData]);

    //deleteResponse responses

    useEffect(() => {
        if (deleteDepartmentMasterResponse.isSuccess) {
            alertMessage("Department master updated successfully", "success");
            setCall("Y");
        } else if (deleteDepartmentMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteDepartmentMasterResponse.isSuccess, deleteDepartmentMasterResponse.isError]);

    return (
        <div className="mt-2 overflow-y-auto">
            <div className="d-flex align-items-center justify-content-between flex-sm-row flex-column mb-2">
                <div className="d-flex align-items-center w-100 px-2">
                    <h5
                        className="m-0 px-0 d-flex align-items-center text-cm-active-primary1"
                        style={{ fontWeight: "700" }}
                    >
                        {reportName}
                    </h5>
                </div>
                <div className="d-flex align-items-center justify-content-start justify-content-sm-end cursor-pointer w-100">
                    <div className="d-flex px-2 align-items-center mt-1">
                        <Button
                            variant="danger"
                            className="d-flex align-items-center me-0 text-nowrap"
                            onClick={handleShow}
                        >
                            <BsPlus />
                            Add
                        </Button>
                    </div>
                    {departmentMasterResponse.isLoading ||
                        deleteDepartmentMasterResponse.isLoading? (
                        <Loading />
                    ) : (
                        ""
                    )}

                    {show && (
                        <MasterReportData
                            show={show}
                            setShow={setShow}
                            actionType={actionType}
                            reportName={reportName}
                            data={selectedRow}
                            setCall={setCall}
                        />
                    )}
                </div>
            </div>
            <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
                <Table
                    bordered={true}
                    rowKey={"id"}
                    scroll={{ x: 'max-content' }}
                    tableLayout="fixed"
                    pagination={{
                        total: (() => {
                            switch (reportName) {
                                case REPORT_NAME.DEPARTMENT_MASTER:
                                    return totalDepartmentMaster;
                                default:
                                    return dataSource.length;
                            }
                        })(),
                        responsive: true,
                        current: currentpage,
                        // showSizeChanger: true,  
                        pageSizeOptions: [10, 20, 30],
                        onChange: (page, pageSize) => {
                            paginationChange(page, pageSize);
                        },
                        pageSize: pageSize,
                    }}
                    columns={columData}
                    dataSource={dataSource}
                />
            </div>
        </div>
    );
};
export default AllMasterReports2;